import { ModuleModel } from '../../module.model.interface';
import { ProfileModel } from '../../profile/model/profile.model';

export class BulletinParticipantDescriptor implements ModuleModel {
  public discriminator = 'BulletinParticipantDescriptor';

  public id: string;
  public bulletinId: string;
  public profileId: string;
  public externalCommunicationAllowed: boolean;
  public href: string;
  public modified: Date;
  public deleted: Date;

  public profileDetail: ProfileModel;
  public profileFullName: string;

  constructor(options?: {
    id: string;
    bulletinId: string;
    profileId: string;
    externalCommunicationAllowed: boolean;
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.bulletinId = options.bulletinId;
      this.profileId = options.profileId;
      this.externalCommunicationAllowed = options.externalCommunicationAllowed;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bulletin.participant/model/bulletin.participant.ts